<div *ngIf="hideVoidC && showTransaction == false" class="alert alert-danger box-msg" role="alert">
	<strong>Last transaction is already voided!</strong>
</div>
<div id="searchoption" class="panel-collapse" *ngIf="showTransaction">
	<div class="panel-body">
		<form class="form-horizontal">
			<div>
				<div class="form-group">
					<label class="col-sm-4 control-label"> Date Time - </label>
					{{ this.lastTransactionList[0].TransactionDTToString }}
				</div>
				<br />
				<div class="form-group">
					<label class="col-sm-4 control-label"> Transaction - </label>
					{{ this.lastTransactionList[0].PointsTransactionTypeDesc }}
				</div>
				<br />
				<div class="form-group">
					<label class="col-sm-4 control-label"> Description -</label>
					{{ this.lastTransactionList[0].PointsItemDesc }}
				</div>
				<br />
				<div class="form-group">
					<label class="col-sm-4 control-label"> Amount -Description -</label>
					{{ this.lastTransactionList[0].PointsItemValue }}

					<br />

					<button class="col-sm-4" type="button" class="btn btn-primary" (click)="submitClick()" href="javascript:void(0);">Void</button>
					<button class="col-sm-4" type="button" class="btn btn-danger" (click)="cancelClick()" href="javascript:void(0);">Cancel</button>
				</div>
			</div>
		</form>
	</div>
</div>
